import React from 'react'
import { ButtonBase } from './styles'

const SmallButtonLabelSecondary = ({ children, ...props }) => (
  <ButtonBase {...props}>{children}</ButtonBase>
)

export default SmallButtonLabelSecondary
